import { render, staticRenderFns } from "./DiscoverCard.vue?vue&type=template&id=d11cac04&scoped=true&"
import script from "./DiscoverCard.vue?vue&type=script&lang=js&"
export * from "./DiscoverCard.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverCard.vue?vue&type=style&index=0&id=d11cac04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11cac04",
  null
  
)

export default component.exports